/**
 * Node modules
 */
import NProgress from 'nprogress';

NProgress.configure({ showSpinner: false });
export default NProgress;
